import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=534fa41f"
import script from "./Certificado.vue?vue&type=script&lang=js"
export * from "./Certificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534fa41f')) {
      api.createRecord('534fa41f', component.options)
    } else {
      api.reload('534fa41f', component.options)
    }
    module.hot.accept("./Certificado.vue?vue&type=template&id=534fa41f", function () {
      api.rerender('534fa41f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/usuario/Certificado.vue"
export default component.exports